<template>
  <div>
    <Loader v-if="loading"/>
    <div v-if="!loading">
      <div v-if="$store.getters.isLargeScreen">

        <div v-if="showHelloAndWelcome">
          <vs-row>
            <vs-col class="px-6" vs-w="8">
              <HelloAndWelcome />
              <vs-row>
                <vs-col class="px-6" vs-w="6">
                  <TaskList :key="$store.getters.todayKey" />
                </vs-col>

                <vs-col class="px-6" vs-w="6">
                  <RoutineList :key="$store.getters.todayKey" :initWithSidebarOpen="initWithRoutineSidebarOpen" :getInspiredFilter="getInspiredFilter" />
                </vs-col>
              </vs-row>
            </vs-col>

            <vs-col class="px-6" vs-w="4">
              <GoalsList :key="$store.getters.todayKey" :initWithGoalSidebarOpen="initWithGoalSidebarOpen"/>
            </vs-col>

          </vs-row>

        </div>
        <div v-else>
          <vs-row>
            <vs-col class="px-6" vs-w="4">
              <TaskList :key="$store.getters.todayKey" />
            </vs-col>

            <vs-col class="px-6" vs-w="4">
              <RoutineList :key="$store.getters.todayKey" :initWithSidebarOpen="initWithRoutineSidebarOpen" :getInspiredFilter="getInspiredFilter" />
            </vs-col>

            <vs-col class="px-6" vs-w="4">
              <GoalsList :key="$store.getters.todayKey" :initWithGoalSidebarOpen="initWithGoalSidebarOpen"/>
            </vs-col>
          </vs-row>
        </div>
      </div>
      <vs-tabs alignment="fixed" v-else>
        <keep-alive>
          <vs-tab label="tasks">
            <!-- <HelloAndWelcome v-if="showHelloAndWelcome"/> -->
            <TaskList :key="$store.getters.todayKey" />
          </vs-tab>
        </keep-alive>
        <keep-alive>
          <vs-tab label="routines">
            <RoutineList :key="$store.getters.todayKey" :initWithSidebarOpen="initWithRoutineSidebarOpen":getInspiredFilter="getInspiredFilter" />
          </vs-tab>
        </keep-alive>
        <keep-alive>
          <vs-tab label="goals">

            <GoalsList :key="$store.getters.todayKey" :initWithGoalSidebarOpen="initWithGoalSidebarOpen"/>
          </vs-tab>
        </keep-alive>
      </vs-tabs>

        <!-- <GoalEditForm -->
          <!-- :editedEntity="goalEditedEntity" -->
          <!-- @close="goalEditedEntity=null" -->
        <!-- /> -->

<!--       <Sidebar :initValue="dreamSidebarActive" title="New Dream" @close="dreamSidebarActive=false">
        <DreamEditForm
          class="pt-2"
          :editedEntity="{}"
          @close="dreamSidebarActive=false"/>
      </Sidebar> -->

    </div>
  </div>
</template>

<script>
import TaskList from '../Tasks/TaskList'
import RoutineList from '../Routines/RoutineList'
import GoalsList from '../Goals/ListNew'
import DreamsList from '../Dreams/ListNew'
import Sidebar from '../Generic/Sidebar'
import DreamEditForm from '../Dreams/EditForm'
import GoalEditForm from '../Goals/EditForm'
import Loader from '../Generic/Loader'
import * as DateHelper from '@/helpers/date'
import HelloAndWelcome from '../Generic/HelloAndWelcome'

export default {
  components: {
    RoutineList,
    TaskList,
    DreamsList,
    GoalsList,
    Sidebar,
    DreamEditForm,
    GoalEditForm,
    Loader,
    HelloAndWelcome
  },
  props: ['initWithRoutineSidebarOpen', 'initWithGoalSidebarOpen', 'getInspiredFilter'],
  data () {
    return {
      interval: null,
      loading: true,
      // showHelloAndWelcome: false,
    }
  },
  // watch: {
  //   '$store.getters.tasksDataLoaded': {
  //     immediate: true,
  //     handler (loaded) {
  //         console.log('Planner $store.getters.tasksDataLoaded', loaded, this.$store.getters.allTasks.length)
  //         if (loaded) {
  //           this.showHelloAndWelcome = this.$store.getters.allTasks.length < 1
  //         }
  //       }
  //     },
  // },
  computed: {
    showHelloAndWelcome () {
      return !this.$store.getters.helloAndWelcomeStarted &&
      this.$store.getters.daysFromRegistration < 3
    },
  },
  mounted () {
    // console.log('!!!!!!!!!!!PLANNER MOUNTED')
    // this.$store.dispatch('bindTasks').then(() => {

    //   console.log('<<<<<>>>>>> tasks bound', this.$store.getters.allTasks.length)

    //   this.showHelloAndWelcome = this.$store.getters.allTasks.length < 1
    // }).catch((error) => {
    //     console.error('/////error //////',error);
    // });

    // this.loading = false


    // setTimeout(() => {
      // if (typeof initLandbot === "function" ) {
      //   initLandbot({
      //     customData: this.customData
      //   })

        // setTimeout(() => {
        //   if (true) {

        //     if (typeof landbotNewMessageSignalizationStart === "function" ) {
        //       landbotNewMessageSignalizationStart()
        //     }
        //   }
        // }, 5000)
      // }
    // }, 5000)


    setTimeout(() => {
      if (window.smartlook) {
      window.smartlook('identify',
        this.$store.getters.userId,
        this.customData)
    }

      console.log("window.myLandbot", window.myLandbot)

      if (window.myLandbot) {
        window.myLandbot.setCustomData(this.customData)


        // if (typeof landbotNewMessageSignalizationStop === "function" ) {
        //   window.myLandbot.core.events.on('landbot-widget-close', () => {
        //     landbotNewMessageSignalizationStop()
        //   });
        // }
      }
     }, 10000
    )


    setTimeout(() => { this.loading = false }, 100)
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
}
</script>
